import React from "react";
import { useTranslation } from "react-i18next";
import { NumberInput } from "../../common/NumberInput";

export function GeneralInfoSection({ values, setField }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <NumberInput
          label={t("price")}
          name="price"
          value={values.price}
          placeholder={t("price")}
          onChange={(e) => setField("price", e.target.value)}
          min={0}
          step={0.01}
          required
        />
        <NumberInput
          label={t("calories")}
          name="calories"
          value={values.calories}
          placeholder={t("calories")}
          onChange={(e) => setField("calories", e.target.value)}
          min={0}
        />
      </div>
    </div>
  );
}